/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CRSFFindingSourceType = {
    Firehose: 'firehose',
    Asm: 'asm'
} as const;
export type CRSFFindingSourceType = typeof CRSFFindingSourceType[keyof typeof CRSFFindingSourceType];


export function CRSFFindingSourceTypeFromJSON(json: any): CRSFFindingSourceType {
    return CRSFFindingSourceTypeFromJSONTyped(json, false);
}

export function CRSFFindingSourceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFFindingSourceType {
    return json as CRSFFindingSourceType;
}

export function CRSFFindingSourceTypeToJSON(value?: CRSFFindingSourceType | null): any {
    return value as any;
}

